export default __webpack_public_path__ + "static/media/ELK.d410c6a4.png";